import React from 'react';
import { Routes, Route } from 'react-router-dom';

import routes from 'core/routes';

import EntitiesFormPublicSubmission from 'containers/EntitiesFormPublicSubmission';
import NotFound from 'containers/Error/Pages/NotFound/NotFound';
import SharedDocument from 'containers/SharedDocument';
import EntitiesFormPublicSubmissionList from 'containers/EntitiesFormPublicSubmission/EntitiesFormPublicSubmissionList';
import AcknowledgementPage from 'containers/AcknowledgementPage';
import { EntityModules } from 'core/constants';

import Dashboard from '../../../Dashboard';
import Login from '../../../Login';
import { PrivateRoute, PublicRoute } from '../../../../components/Route';
import UserRoute from '../../../../components/Route/UserRoute';
import HomeRedirect from '../HomeRedirect';

const Routing: React.FunctionComponent = (): React.ReactElement => (
  <Routes>
    <Route path="/" element={<HomeRedirect />} />
    <Route
      path={String(routes.publicForm.details)}
      element={
        <PublicRoute path={String(routes.publicForm.details)}>
          <EntitiesFormPublicSubmission />
        </PublicRoute>
      }
    />
    <Route
      path={String(routes.publicFormList.details)}
      element={
        <PublicRoute path={String(routes.publicFormList.details)}>
          <EntitiesFormPublicSubmissionList />
        </PublicRoute>
      }
    />
    <Route
      path={routes.login}
      element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      }
    />
    <Route
      path={String(routes.shared.details)}
      element={
        <PublicRoute>
          <SharedDocument />
        </PublicRoute>
      }
    />
    <Route
      path={String(routes.embeddedAcknowledgement.details)}
      element={
        <PrivateRoute>
          <UserRoute isAuthorizedUser={(user) => user.activeEntityModules.includes(EntityModules.Documents)}>
            <AcknowledgementPage embedded />
          </UserRoute>
        </PrivateRoute>
      }
    />
    <Route
      path="/*"
      element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      }
    />
    <Route
      path="*"
      element={
        <PublicRoute>
          <NotFound />
        </PublicRoute>
      }
    />
  </Routes>
);

export default Routing;
